import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Spinner } from "@fluentui/react-components";
import "./CSS/InitComponent.css";

import SideBarContainer from "../Containers/SideBarContainer/SideBarContainer";
import HeaderContainer from "../Containers/Header/HeaderContainer";
import LicencesContainer from "../Containers/Licences/LicencesContainer";
import ListMediaContainer from "../Containers/Medias/ListMediaContainer";
import AddMediaContainer from "../Containers/Medias/AddMediaContainer";
import HomeContainer from "../Containers/HomeContainer";
import ListAgentProfilesContainer from "../Containers/AgentProfiles/ListAgentProfilesContainer";
import ListAnalyticsProfilesContainer from "../Containers/Analytics/ListAnalyticsProfilesContainer";
import AnalyticsProfileContainer from "../Containers/Analytics/AnalyticsProfileContainer";
import ListCallFlowsContainer from "../Containers/CallFlows/ListCallFlowsContainer";
import CallFlowContainer from "../Containers/CallFlows/CallFlowContainer";
import CallFlowDiagramContainer from "../Containers/CallFlows/CallFlowDiagramContainer";
import ListIaAgentsContainer from "../Containers/IaAgent/ListIaAgentsContainer";
import IaAgentContainer from "../Containers/IaAgent/IaAgentContainer";
import ListChatFlowsContainer from "../Containers/ChatFlows/ListChatFlowsContainer";
import ChatFlowContainer from "../Containers/ChatFlows/ChatFlowContainer";
import ChatFlowDiagramContainer from "../Containers/ChatFlows/ChatFlowDiagramContainer";
import EntitiesContainer from "../Containers/Entities/EntitiesContainer";
import EntitieContainer from "../Containers/Entities/EntitieContainer";
import ListGroupsContainer from "../Containers/Groups/ListGroupsContainer";
import GroupContainer from "../Containers/Groups/GroupContainer";
import ListAgentsContainers from "../Containers/Agents/ListAgentsContainers";
import AgentsContainer from "../Containers/Agents/AgentsContainer";
import ListQueuesContainer from "../Containers/Queues/ListQueuesContainer";
import ListVariablesContainer from "../Containers/Variables/ListVariablesContainer";
import VariablesContainer from "../Containers/Variables/VariablesContainer";
import ListWorkflowsContainer from "../Containers/Workflows/ListWorkflowsContainer";
import WorkflowsContainer from "../Containers/Workflows/WorkflowsContainer";
import QueuesContainer from "../Containers/Queues/QueuesContainer";
import AgentsProfileContainer from "../Containers/AgentProfiles/AgentsProfileContainer";
///import Dashboard from "./Dashboard/Dashboard";
import AnalyticsDashboard from "./Dashboard/AnalyticsDashboard";
import RealtimeDashboardContainer from "../Containers/RealtimeDashboard/RealtimeDashboardContainer";
import ScopeListComponent from "./Dashboard/ScopeListComponent";
import { exampleDashboard } from "./Dashboard/exampleDashboard";
import GlobalSettingsContainer from "../Containers/GlobalSettings/GlobalSettingsContainer";

import {
  getAllLicences,
  getAllRoles,
  getAllMedia,
  GetAllAgent,
  GetAgent,
  GetAllCallFlow,
  GetAllAgentProfile,
  getAllQueue,
  GetAllChatFlow,
  getAllPermissions,
  getAllGroups,
  getPartnerTenants,
  getAllVariables,
  getAllWorkflows,
  GetAllAnalyticsProfiles,
} from "../Services/HeedifyServices";

import { getAccessToken } from "../Services/GraphServices";
import { AbilityProvider } from "../Contexts/AbilityContext";
import {
  defineAbilityFromPermissions,
  generateConsolidatedPermissions,
} from "../Utils/AbilityUtils";
import RecordingContainer from "../Containers/RecordingsManagement/RecordingContainer";
import ProtectedRoute from "./ProtectedRoute";

const InitComponent = (props) => {
  const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  let userId = null;
  let tenantId = null;
  if (accounts[0]) {
    userId = accounts[0].localAccountId;
    tenantId = accounts[0].tenantId;
  }

  const [ability, setAbility] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  useEffect(() => {
    if (!instance || !activeAccount) return;

    (async () => {
      try {
        // Restaurer le tenant actif depuis sessionStorage ou utiliser celui du compte
        const savedTenantId = sessionStorage.getItem('activeTenantId');
        const activeTenantToUse = savedTenantId || tenantId;
        
        if (activeTenantToUse) {
          props.setActiveTenant(activeTenantToUse);
        }

        const token = await getAccessToken(instance, activeAccount);
       
        setAccessToken(token);
        // Utiliser le tenant actif pour récupérer les permissions
        const data = await getAllPermissions(activeTenantToUse, token);
        const { scopes, roles } = data;
        props.setScopes(scopes);
        props.setRoles(roles);
        props.setScopesNames(Object.keys(scopes));
 
        // Fusion et définition des droits CASL
        const consolidated = generateConsolidatedPermissions(roles, scopes);
        props.setPermissions(consolidated);
        const caslAbility = defineAbilityFromPermissions(consolidated);
        setAbility(caslAbility);

        // Fetch partner tenants
        const partnerTenantsData = await getPartnerTenants(tenantId, token);
        
        // Extraire myTenant et tenants de la nouvelle structure
        const { myTenant, tenants } = partnerTenantsData;
        
        // Utiliser myTenant si disponible, sinon créer un tenant par défaut
        const currentTenant = myTenant || {
          customerName: "Mon compte",
          tenantId: tenantId
        };
        
        // Combiner le tenant actuel avec les tenants partenaires
        const allTenants = [currentTenant, ...(tenants || [])];
        
        props.setPartnerTenants(allTenants);

        // Vérifier si le tenant restauré est valide
        const validTenantIds = allTenants.map(t => t.tenantId);
        if (activeTenantToUse !== tenantId && !validTenantIds.includes(activeTenantToUse)) {
          console.warn("⚠️ Tenant invalide dans sessionStorage, utilisation du tenant du compte");
          sessionStorage.removeItem('activeTenantId');
          props.setActiveTenant(tenantId);
        }

        // Chargement des autres données
        fetchData(token, scopes);
      } catch (error) {
        console.error("❌ Erreur d'initialisation :", error);
      }
    })();
  }, [instance, activeAccount]);

  // Recharger les données quand le tenant actif change
  useEffect(() => {
    if (!props.ACTIVE_TENANT || !instance || !activeAccount) return;
    
    // Éviter le double chargement initial uniquement au premier render
    if (props.ACTIVE_TENANT === tenantId && !ability) return;

    (async () => {
      try {
        const token = await getAccessToken(instance, activeAccount);
        
        // Utiliser le tenant actif pour récupérer les permissions
        const data = await getAllPermissions(props.ACTIVE_TENANT, token);
        const { scopes, roles } = data;

        props.setScopes(scopes);
        props.setRoles(roles);
        props.setScopesNames(Object.keys(scopes));

        // Régénérer les abilities CASL avec les nouvelles permissions
        const consolidated = generateConsolidatedPermissions(roles, scopes);
        props.setPermissions(consolidated);
        const caslAbility = defineAbilityFromPermissions(consolidated);
        setAbility(caslAbility);

        // Recharger les données avec le nouveau tenant
        fetchData(token, scopes);
      } catch (error) {
        console.error("❌ Erreur lors du rechargement des données:", error);
      }
    })();
  }, [props.ACTIVE_TENANT]);

  const fetchData = (token, scopes) => {
    if (!token || !scopes) return;

    const scopeNames = Object.keys(scopes || {});
    if (scopeNames.length === 0) return;

    // Utiliser props.ACTIVE_TENANT au lieu de tenantId
    const currentTenantId = props.ACTIVE_TENANT || tenantId;

    Promise.all([
      getAllRoles(currentTenantId, token),
      GetAllAgentProfile(currentTenantId, token),
      getAllMedia(currentTenantId, token),
      GetAllAnalyticsProfiles(currentTenantId, token),
    ])
      .then(([roles, profiles, medias, analyticsProfiles]) => {
        props.setAllRoles(roles);
        props.setAgentProfiles(profiles.data);

        // Set Analytics Profiles in Redux
        if (analyticsProfiles.success && analyticsProfiles.data) {
          const analyticsProfilesObj = {};
          analyticsProfiles.data.forEach(p => {
            analyticsProfilesObj[p.id] = p;
          });
          props.setAnalyticsProfiles(analyticsProfilesObj);
        }

        // Ajouter scope "default" à chaque média
        const mediasWithScope = medias.map(media => ({
          ...media,
          scope: "default"
        }));
        props.setMedias(mediasWithScope);
        
      })
      .catch(console.error);

    const licencesPromises = scopeNames.map((s) =>
      getAllLicences(currentTenantId, token, s, token)
    );

    const agentsPromises = scopeNames.map((s) =>
      GetAllAgent(currentTenantId, userId, s, token)
    );
    const callFlowPromises = scopeNames.map((s) =>
      GetAllCallFlow(currentTenantId, userId, s, token)
    );
    const groupsPromises = scopeNames.map((s) =>
      getAllGroups(currentTenantId, s, userId, token)
    );
    const chatFlowPromises = scopeNames.map((s) =>
      GetAllChatFlow(currentTenantId, userId, s, token)
    );
    const queuesPromises = scopeNames.map((s) =>
      getAllQueue(currentTenantId, userId, s, token)
    );

    const variablesPromises = scopeNames.map((s) =>
      getAllVariables(currentTenantId, s, token)
    );

    const workflowsPromises = scopeNames.map((s) =>
      getAllWorkflows(currentTenantId, s, token)
    );

    Promise.all(licencesPromises).then((results) => {
      // Formater les licences par scope
      const licencesByScope = {};
      results.forEach((result) => {
        if (result && result.RowKey) {
          licencesByScope[result.RowKey] = result;
        }
      });
      props.setLicences(results);
      props.setAvailableLicences(licencesByScope);
    });
    
    Promise.all(agentsPromises).then((data) => props.setAgents(data.flat()));
    Promise.all(chatFlowPromises).then((data) => {
      // Filtrer les objets vides et concaténer tous les flows
      const allChatFlows = data.flat().filter(item => item && Object.keys(item).length > 0);
      
      // Séparer les flows WhatsApp (ceux qui ont whatsAppId et teamsBotId)
      const whatsAppFlows = allChatFlows.filter(flow => 
        flow.whatsAppId && flow.teamsBotId
      );
      
      // Les chatflows normaux (sans whatsAppId et teamsBotId)
      const regularChatFlows = allChatFlows.filter(flow => 
        !flow.whatsAppId || !flow.teamsBotId
      );
      
      props.setChatFlows(regularChatFlows);
      props.setWhatsAppFlows(whatsAppFlows);
    });
   Promise.all(queuesPromises).then((data) => {
  const mergedQueues = data
    .filter(item => item && typeof item === "object" && !Array.isArray(item) && Object.keys(item).length > 0)
    .reduce((acc, curr) => ({ ...acc, ...curr }), {});

      props.setQueues(mergedQueues);
    });

    // Handle groups and supervised agents
    Promise.all(groupsPromises).then((data) => {
      const groups = data.flat();
      props.setGroups(groups);

      // Extract supervised agent IDs from groups
      const supervisedAgentIds = [];
      groups.forEach((group) => {
        if (group.agentsIds?.includes(userId)) {
          const agentDetails = group.agentDetails || {};
          // Sans la condition isSupervisor: si l'utilisateur est dans le groupe,
          // tous les agents du groupe sont considérés comme supervisés
          Object.keys(agentDetails).forEach((agentId) => {
            if (!supervisedAgentIds.includes(agentId)) {
              supervisedAgentIds.push(agentId);
            }
          });
        }
      });

      // Fetch agent profiles for supervised agents
      if (supervisedAgentIds.length > 0) {
        const agentProfilesPromises = supervisedAgentIds.map((agentId) =>
          GetAgent(currentTenantId, userId, agentId, token)
            .then((agentProfile) => ({ agentId, agentProfile }))
            .catch((error) => {
              console.error(`Error fetching profile for agent ${agentId}:`, error);
              return { agentId, agentProfile: null };
            })
        );

        Promise.all(agentProfilesPromises).then((results) => {
          const agentsProfiles = {};
          const validSupervisedAgentIds = [];

          results.forEach(({ agentId, agentProfile }) => {
            if (agentProfile && Object.keys(agentProfile).length > 0) {
              agentsProfiles[agentId] = agentProfile;
              validSupervisedAgentIds.push(agentId);
            }
          });

          props.setSupervisedAgentDetails(agentsProfiles);
          props.setSupervisedAgentIds(validSupervisedAgentIds);
        });
      }
    });

    // Handle call flows and extract IDs for recording access
    Promise.all(callFlowPromises).then((data) => {
      const mergedCallFlows = Object.assign({}, ...data);
      const flattened = Object.values(mergedCallFlows);
      props.setCallFlows(flattened);
      // Extract call flow IDs where user has recording access
      const callFlowsIds = Object.entries(mergedCallFlows)
        .filter(([_, callflow]) =>
          callflow.callRecordingReadersDetails &&
          Object.keys(callflow.callRecordingReadersDetails).includes(userId)
        )
        .map(([callflowId]) => callflowId);

      props.setCallFlowsIds(callFlowsIds);
    });

    Promise.all(variablesPromises).then((data) => props.setVariables(data.flat()));
   
    Promise.all(workflowsPromises).then((data) => {
      const allWorkflows = data.flat();
      props.setWorkflows(allWorkflows);
    });
  };

  if (!ability)
    return (
      <div className="init-loading-container">
     
          <Spinner size="extra-large"  />
        </div>
   
    );
  return (
    <AbilityProvider ability={ability}>
      <div className="init-container">
        <HeaderContainer />
        <Router>
          <div className="init-main-layout">
            <SideBarContainer />
            <Routes>
              <Route path="/" element={<div className="init-route-container"><HomeContainer /></div>} />
              <Route
                path="/analytics"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <ScopeListComponent />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/realtime-dashboard"
                element={
                  <ProtectedRoute module="realTimeDashboard">
                    <div className="init-route-container">
                      <RealtimeDashboardContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analytics/:scope"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <AnalyticsDashboard
                        tenantId={tenantId}
                        token={accessToken}
                      />
                    </div>
                  </ProtectedRoute>
                }
              />
           
              <Route path="/recording" element={
                <ProtectedRoute module="Recordings">
                  <div className="init-route-container">
                    <RecordingContainer />
                  </div>
                </ProtectedRoute>
              } />
             
              <Route path="/globalSettings" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              {/* Consent Callback Routes */}
              <Route path="/ConsentReports" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/Consentpresence" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/Consentcc" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/ConsentAgentConsole" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/ConsentAgentConsoleUnify" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/ConsentAgentConsoleEurope" element={
                <ProtectedRoute module="GlobalSettings">
                  <div className="init-route-container">
                    <GlobalSettingsContainer />
                  </div>
                </ProtectedRoute>
              } />
             
              <Route path="/queues" element={
                <ProtectedRoute module="Queue">
                  <div className="init-route-container">
                    <ListQueuesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/queues/:queueId" element={
                <ProtectedRoute module="Queue">
                  <div className="init-route-container">
                    <QueuesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/callFlows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListCallFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/callFlows/:callFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <CallFlowContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/callFlows/diagram/:callFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-diagram-container">
                      <CallFlowDiagramContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/iaAgent" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListIaAgentsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/iaAgent/:iaAgentId" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <IaAgentContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/chatFlows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListChatFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/chatFlows/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <ChatFlowContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/chatFlows/diagram/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-diagram-container">
                      <ChatFlowDiagramContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/whatsapp" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListChatFlowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/whatsapp/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-container">
                      <ChatFlowContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/whatsapp/diagram/:chatFlowId"
                element={
                  <ProtectedRoute module="Flow">
                    <div className="init-route-diagram-container">
                      <ChatFlowDiagramContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/groups" element={
                <ProtectedRoute module="Group">
                  <div className="init-route-container">
                    <ListGroupsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/groups/:groupId/:scopeParam"
                element={
                  <ProtectedRoute module="Group">
                    <div className="init-route-container">
                      <GroupContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/entities" element={
                <ProtectedRoute module="Entity">
                  <div className="init-route-container">
                    <EntitiesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/entities/:entityName"
                element={
                  <ProtectedRoute module="Entity">
                    <div className="init-route-container">
                      <EntitieContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/agents" element={
                <ProtectedRoute module="Agent">
                  <div className="init-route-container">
                    <ListAgentsContainers />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/agents/:agentId" element={
                <ProtectedRoute module="Agent">
                  <div className="init-route-container">
                    <AgentsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route
                path="/agentsProfiles"
                element={
                  <ProtectedRoute module="Agent">
                    <div className="init-route-container">
                      <ListAgentProfilesContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/agentsProfiles/:profileId"
                element={
                  <ProtectedRoute module="Agent">
                    <div className="init-route-container">
                      <AgentsProfileContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analyticsProfile"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <ListAnalyticsProfilesContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/analyticsProfile/:profileId"
                element={
                  <ProtectedRoute module="Analytics">
                    <div className="init-route-container">
                      <AnalyticsProfileContainer />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="/medias" element={
                <ProtectedRoute module="Media">
                  <div className="init-route-container">
                    <ListMediaContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/medias/addMedia" element={
                <ProtectedRoute module="Media">
                  <div className="init-route-container">
                    <AddMediaContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/licences" element={
                <ProtectedRoute module="Licences">
                  <div className="init-route-container">
                    <LicencesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/variables" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListVariablesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/variables/:variableId" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <VariablesContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/workflows" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <ListWorkflowsContainer />
                  </div>
                </ProtectedRoute>
              } />
              <Route path="/workflows/:workflowId" element={
                <ProtectedRoute module="Flow">
                  <div className="init-route-container">
                    <WorkflowsContainer />
                  </div>
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </div>
    </AbilityProvider>
  );
};

export default InitComponent;
